import React, { ReactElement } from 'react';
import { ImageHelperProps } from '../../ImageHelper/ImageHelper.types';
import { HunterTireResult } from '../../../API/Enums';
import css from './HunterTireCard.module.scss';

export interface IHunterTireCardProps {
    imageHelper: ReactElement<ImageHelperProps>;
    status?: HunterTireResult;
    label?: string;
    tread?: string;
}

export const HunterTireCard = React.memo((props: IHunterTireCardProps) => (
    <div className={css.hunterTireCard}>
        <h6 className={css.label}>{props.label}</h6>
        <div className={css.tire}>
            {props.imageHelper}
            <div className={css[`info-bg-${props.status || HunterTireResult.noResult}`]}>{props.tread}</div>
        </div>
    </div>
));
